<div class="output-edit-container">
  <div class="header">
    <button class="back-button" (click)="back()">
      <img src="assets/icons/arrow-back.svg" width="24" height="24" [alt]="'common.back' | translate" />
    </button>
    <h2>{{ 'output.edit.title' | translate }}</h2>
  </div>

  <div *ngIf="this.output == null">{{ 'output.edit.not_found' | translate }}</div>

  <div *ngIf="this.output != null" class="output-edit-form">
    <div class="form-group">
      <label for="name">{{ 'output.edit.id' | translate: { id: output.id } }}</label>      
    </div>
    <div class="form-group">
      <label for="name">{{ 'output.edit.name' | translate }}</label>
      <input type="text" id="name" [(ngModel)]="output.name" />
    </div>

    <div class="form-group">
      <label for="type">{{ 'output.edit.type' | translate }}</label>
      <select id="type" [(ngModel)]="output.type" (ngModelChange)="onTypeChange()">
        <option *ngFor="let type of outputTypes" [value]="type.value">
          {{ type.label | translate }}
        </option>
      </select>
    </div>

    <!-- Timer-specific fields -->
    <div class="form-group" *ngIf="output.type === 'Timed'">
      <label for="on">{{ 'output.edit.on_time' | translate }}</label>
      <div class="number-input-group">
        <button class="number-btn" (click)="decrementValue('on')">-</button>
        <input type="number" id="on" [(ngModel)]="output.on" min="0" />
        <button class="number-btn" (click)="incrementValue('on')">+</button>
      </div>
    </div>

    <div class="form-group" *ngIf="output.type === 'Timed'">
      <label for="off">{{ 'output.edit.off_time' | translate }}</label>
      <div class="number-input-group">
        <button class="number-btn" (click)="decrementValue('off')">-</button>
        <input type="number" id="off" [(ngModel)]="output.off" min="0" />
        <button class="number-btn" (click)="incrementValue('off')">+</button>
      </div>
    </div>

    <!-- Standard output fields -->
    <div class="form-group" *ngIf="output.type === 'Simple'">
      <label for="limit">{{ 'output.edit.limit' | translate }}</label>
      <div class="number-input-group">
        <button class="number-btn" (click)="decrementValue('limit')">-</button>
        <input type="number" id="limit" [(ngModel)]="output.limit" min="0" />
        <button class="number-btn" (click)="incrementValue('limit')">+</button>
      </div>
    </div>

    <div class="form-group">
      <label for="default">{{ 'output.edit.default' | translate }}</label>
      <select id="default" [(ngModel)]="output.default">
        <option *ngFor="let value of defaultValues" [value]="value.value">
          {{ value.label | translate }}
        </option>
      </select>
    </div>

    <div class="form-group inline">
      <label for="notify">{{ 'output.edit.notify' | translate }}</label>
      <label class="switch">
        <input type="checkbox" id="notify" [(ngModel)]="output.notify" (ngModelChange)="onNotifyChange(output.id)" />
        <span class="slider round"></span>
      </label>
    </div>
    <div class="form-group" *ngIf="output.notify">
      <label for="notifyOn">{{ 'output.edit.notify_on' | translate }}</label>
      <input type="text" id="notifyOn" [(ngModel)]="output.notifyOn" />      
      <label for="notifyOff">{{ 'output.edit.notify_off' | translate }}</label>
      <input type="text" id="notifyOff" [(ngModel)]="output.notifyOff" />      
    </div>

    <div class="form-group inline">
      <label for="alice">Alice</label>
      <label class="switch">
        <input type="checkbox" id="alice" [(ngModel)]="output.alice" (ngModelChange)="onAliceChange()" />
        <span class="slider round"></span>
      </label>
    </div>

    <div class="form-group" *ngIf="output.alice">
      <label for="room">{{ 'output.edit.room' | translate }}</label>
      <input type="text" id="room" [(ngModel)]="output.room" required />      
    </div>

    <div class="error-message" *ngIf="formError">{{ formError | translate }}</div>
    
    <div class="actions">      
      <button class="cancel-button" (click)="back()">{{ 'common.back' | translate }}</button>
      <button class="save-button" (click)="save()">{{ 'common.save' | translate }}</button>
    </div>
  </div>

</div>
